import React, { useState, useEffect } from "react";
import queryString from "query-string";
import {
  ArticleProps,
  ArticleListProps,
  ArticleListUiProps,
  ArticleSearchDesktopProps,
  ArticleStickyFiltersProps,
  dateRangeType
} from "./types";
import { getNews } from "../../../services/news";
import Dropdown, { customStyles } from "../../../static/Dropdown/Dropdown";
import { dropdownItem } from "../../../static/Dropdown/types";
import DatePickerITF from "../../../dynamic/DatePicker/DatePicker";
import moment from "moment";
import { mediaSizes } from "../../../helpers/utils/index";
import "./index.scss";
import Lightbox from "../../../static/Lightbox/src/Lightbox";
import Loading from "../../../static/Loading/Loading";
import { GalleryInstance } from "../../gallery/src/Gallery";
import { useDebounce } from "../../../helpers";
import { articleList as errors } from "../../../helpers/errors/index";

const formatDate = (date: Date) => {
  const newDate = new Date(date);
  const month = newDate.toLocaleString("en-uk", { month: "long" });
  return `${newDate.getDate()} ${month.slice(0, 3)} ${newDate.getFullYear()}`;
};

const currentLanguages = ["en", "es"];

export const Article = (props: ArticleProps) => {
  const {
    type,
    pageType,
    setShowLB,
    imageUrls,
    index,
    setSelectedImage,
    listingPageUrl
  } = props;

  return (
    <div className="article-list__item">
      {imageUrls && imageUrls[0] && imageUrls[0].imageUrl !== null ? (
        <div className="article-list__img">
          <div>
            <a href={props.articleUrl}>
              <picture
                tabIndex={pageType === "photos" ? 1 : undefined}
                onClick={() => {
                  if (pageType === "photos") {
                    setSelectedImage(index);
                    setShowLB(true);
                  }
                }}
              >
                <source
                  srcSet={`${process.env.HOST ? process.env.HOST : ""}${
                    imageUrls.filter(
                      (prop: any) => prop.cropKey === "Medium"
                    )[0].imageUrl
                  }`}
                  media={`(min-width: ${mediaSizes.tabletLarge}px)`}
                />
                <img
                  alt={props.title}
                  src={`${process.env.HOST ? process.env.HOST : ""}${
                    imageUrls.filter((prop: any) => prop.cropKey === "Small")[0]
                      .imageUrl
                  }`}
                />
              </picture>
            </a>
            {props.circuitLogoUrl ? (
              <img
                alt={props.title}
                className="article-list__img--circuit"
                src={`${process.env.HOST ? process.env.HOST : ""}${
                  props.circuitLogoUrl
                }`}
              />
            ) : null}
          </div>
        </div>
      ) : (
        <div className="article-list__img">
          <div>
            <a href={props.articleUrl}>
              <div className="article-list__img fallback-img">
                <span>No image provided</span>
              </div>
            </a>
            {props.circuitLogoUrl ? (
              <img
                alt={props.title}
                className="article-list__img--circuit"
                src={`${process.env.HOST ? process.env.HOST : ""}${
                  props.circuitLogoUrl
                }`}
              />
            ) : null}
          </div>
        </div>
      )}
      <div className="article-list__item-details-container">
        {props.pageType === "articles" || type == "Article" ? (
          <div className="article-list__item-details">
            <span className="article-list__item-details-category">
              {props.type}
            </span>
            <span className="article-list__item-details-date">
              {formatDate(props.displayDate)}
            </span>
          </div>
        ) : null}
        <p>
          <a href={props.articleUrl}>{props.title}</a>
        </p>
        {props.displayDate ? (
          <span className="article-list__date-mobile">
            {formatDate(props.displayDate)}
          </span>
        ) : null}
        {props.tags ? (
          <div className="article-list__item-tags">
            <ul>
              {props.tags.map(item => {
                let search: any = queryString.parse(location.search);
                search["tag"] = item;
                return (
                  <li key={item}>
                    {!listingPageUrl ? (
                      <a
                        className="btn btn--pill"
                        href={`${location.pathname}?${queryString.stringify(
                          search
                        )}`}
                      >
                        {item}
                      </a>
                    ) : (
                      <a
                        className="btn btn--pill"
                        href={`${listingPageUrl}?${queryString.stringify(
                          search
                        )}`}
                      >
                        {item}
                      </a>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        ) : null}
      </div>
    </div>
  );
};

const ArticleSearchDesktop = (props: ArticleSearchDesktopProps) => {
  const {
    pageType,
    setSearchTerm,
    isSearchDisabled,
    searchTerm,
    LangIsES
  } = props;
  let [timeout, updateTimeout] = React.useState(0);

  return (
    <div
      className={`article-list-navigation-container article-list-navigation-container--${pageType}`}
      style={{ backgroundImage: `url("${props.heroImgUrl}")` }}
    >
      <div className="container">
        <h1>
          {props.categoryName}
          <span> {LangIsES ? "Noticias en español" : props.pageType}</span>
        </h1>
        {pageType === "articles" ? (
          <form
            onSubmit={e => {
              e.preventDefault();
            }}
          >
            <div className="search-component search-component--improved">
              <input
                defaultValue={searchTerm}
                disabled={isSearchDisabled}
                type="text"
                placeholder={
                  LangIsES
                    ? "Buscar noticias en español"
                    : `Search all ${
                        props.categoryName && props.categoryName !== "all"
                          ? props.categoryName + " "
                          : ""
                      }${props.pageType}`
                }
                onChange={e => {
                  if (e.target.value.length > 2) {
                    useDebounce({
                      delay: 600,
                      func: setSearchTerm,
                      timeout,
                      updateTimeout,
                      params: [e.target.value]
                    });
                  } else {
                    setSearchTerm(undefined);
                  }
                }}
              />
            </div>
          </form>
        ) : null}
        <nav className="article-list-navigation">
          <ul>
            {props.pageOptions.map((item: any, index: number) => {
              return (
                <li className="sub-nav__link-header" key={index}>
                  <a className={item.active ? "active" : ""} href={item.value}>
                    {item.label}
                  </a>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export const ArticleStickyFilters = (props: ArticleStickyFiltersProps) => {
  const [isSearchActive, setIsSearchActive] = useState(false);
  const { setTag, pageType, pageOptions } = props;

  let defaultVal = pageOptions.filter(option => {
    return option.label.toLowerCase() === pageType;
  })[0];

  return (
    <div className="sticky-nav sticky-nav--article-list-filters">
      <div className="article-list-filters__container">
        <Dropdown
          customStyles={customStyles}
          options={props.articleCategories}
          defaultValue={props.category}
          placeholder="Category"
          onChange={selectedValue => {
            props.setPage(1);
            props.setCategory(selectedValue);
            setTag("");
          }}
        />
        <Dropdown
          className="dropdown--page-type"
          options={pageOptions}
          customStyles={customStyles}
          placeholder="Articles"
          defaultValue={defaultVal}
          onChange={selectedValue => {
            // redirect to the url provided by the api
            window.location.pathname = selectedValue.value as string;
          }}
        />
        <button
          onClick={() => setIsSearchActive(!isSearchActive)}
          className={
            "article-list-filters__search-btn " +
            (isSearchActive ? "btn--close" : "btn--search")
          }
        />
      </div>
      <div
        className={
          "article-list-filters__search-container" +
          (isSearchActive ? "" : " hidden")
        }
      >
        <input type="text" placeholder="Search news and media" />
      </div>
    </div>
  );
};

export const ArticleListUi = (props: ArticleListUiProps) => {
  const {
    items,
    isLoading,
    totalItems,
    setPage,
    setDateRange,
    setSearchTerm,
    page,
    category,
    initialType,
    dateRange,
    pageType,
    isError,
    type,
    searchTerm,
    setTag,
    LanguageCode = "en"
  } = props;
  const categoryName = category ? category.label : undefined;
  const [showLB, setShowLB] = useState(false);
  const [selectedImage, setSelectedImage] = useState(0);

  const itemsAsGallery = items.map(item => {
    const imageUrls = item.imageUrls.map((imageUrls: any) => {
      let newImageUrls = Object.assign({}, imageUrls);
      newImageUrls.imageUrl = `${process.env.HOST ? process.env.HOST : ""}${
        imageUrls.imageUrl
      }`;
      return newImageUrls;
    });

    let circuitLogoUrl;

    if (item.circuitLogoUrl !== null) {
      circuitLogoUrl = `${process.env.HOST ? process.env.HOST : ""}${
        item.circuitLogoUrl
      }`;
    }

    return {
      thumbnailUrl: `${process.env.HOST ? process.env.HOST : ""}${
        item.thumbnailUrl
      }`,
      headline: item.title,
      description: item.description,
      credit: item.credit,
      caption: item.title,
      circuitLogoUrl,
      imageUrls
    };
  });

  const LangIsES =
    location.pathname.indexOf("/es") == 0 || LanguageCode == "es";
  const values = {
    en: {
      buttonText: "Clear all",
      all: "All"
    },
    es: {
      buttonText: "BORRAR TODO",
      all: "TODOS"
    }
  };

  const isSearchDisabled: boolean =
    dateRange.startDate !== null || dateRange.endDate !== null;

  return (
    <>
      <ArticleSearchDesktop
        searchTerm={searchTerm}
        pageType={pageType}
        pageOptions={props.pageOptions}
        heroImgUrl={props.heroImgUrl}
        categoryName={categoryName}
        isSearchDisabled={isSearchDisabled}
        setSearchTerm={setSearchTerm}
        LangIsES={LangIsES}
      />
      <ArticleStickyFilters
        articleCategories={props.articleCategories}
        pageOptions={props.pageOptions}
        category={props.category}
        setPage={props.setPage}
        setCategory={props.setCategory}
        setTag={setTag}
        pageType={pageType}
      />
      <div className="article-list-container container">
        <div
          className={`article-list-filters article-list-filters--${pageType}`}
        >
          <div className="article-list-filters-container article-list-filters-container--category">
            <Dropdown
              customStyles={customStyles}
              options={props.articleCategories}
              defaultValue={category}
              placeholder={values[LanguageCode].all}
              value={category}
              className="category-dropdown"
              onChange={selectedValue => {
                props.setPage(1);
                props.setCategory(selectedValue);
                props.setTypeId("");
                setTag("");
              }}
            />
            {props.articleTypes &&
            props.pageType === "articles" &&
            !LangIsES ? (
              <Dropdown
                customStyles={customStyles}
                options={props.articleTypes}
                defaultValue={initialType}
                value={type}
                placeholder="All"
                onChange={selectedValue => {
                  props.setPage(1);
                  setTag("");
                  props.setTypeId(selectedValue.value);
                }}
              />
            ) : null}
          </div>
          {props.pageType === "articles" ? (
            <div className="article-list-filters-container article-list-filters-container--dates">
              <DatePickerITF
                disabled={searchTerm !== undefined && searchTerm.length > 0}
                startDate={
                  dateRange.startDate ? dateRange.startDate.toDate() : null
                }
                LanguageCode={LanguageCode}
                endDate={dateRange.endDate ? dateRange.endDate.toDate() : null}
                onDateChange={(startDate: Date, endDate: Date) => {
                  setDateRange({
                    startDate: startDate ? moment(startDate) : null,
                    endDate: endDate ? moment(endDate) : null
                  });
                }}
              />
              <button
                onClick={() => {
                  setDateRange({
                    startDate: null,
                    endDate: null
                  });
                  setPage(1);
                  props.setTypeId("");
                  props.setCategory({
                    value: "",
                    label: "all"
                  });
                }}
                className="btn"
              >
                {values[LanguageCode].buttonText}
              </button>
            </div>
          ) : null}
        </div>
        {isError ? (
          <p className="error-text error-text--article-list">
            {errors.catchMessage}
          </p>
        ) : null}
        <h1 className="article-list-header article-list-header--mobile">
          {LangIsES ? "Noticias en español" : "Top Articles"}
        </h1>
        <div className="article-list">
          {items.length > 0 ? (
            items.map((item, index) => {
              return (
                <Article
                  displayDate={item.displayDate}
                  tags={item.tags}
                  imageUrls={item.imageUrls}
                  articleUrl={item.articleUrl}
                  type={item.type}
                  title={item.title}
                  key={index}
                  index={index}
                  circuitLogoUrl={item.circuitLogoUrl}
                  pageType={pageType}
                  setShowLB={setShowLB}
                  setSelectedImage={setSelectedImage}
                  thumbnailUrl={item.thumbnailUrl}
                  credit={item.credit}
                  description={item.description}
                />
              );
            })
          ) : !isLoading && !isError ? (
            <p className="error-text--article-list">
              {errors.noResultsMessage}
            </p>
          ) : null}
        </div>
        {!isLoading ? (
          items.length !== totalItems ? (
            <div className="article-list__load-more">
              <button
                onClick={() => {
                  setPage(page + 1);
                }}
                className="btn"
              >
                Load more
              </button>
            </div>
          ) : null
        ) : (
          <Loading />
        )}
        <Lightbox
          callback={() => {
            setShowLB(false);
          }}
          show={showLB}
          className={"lightbox--gallery"}
        >
          <GalleryInstance
            selectedImage={selectedImage}
            setSelectedImage={setSelectedImage}
            isLightBox
            gallery={itemsAsGallery}
          />
        </Lightbox>
      </div>
    </>
  );
};

interface queryParams {
  categoryId?: string | number;
  typeId?: string;
  startDate?: string;
  endDate?: string;
  tournamentId?: string;
  playerId?: string;
  tag?: string;
  searchTerm?: string;
}

export const setUrlParams = (
  qs: queryParams,
  categoryId?: string | number,
  typeId?: string,
  dateRange?: dateRangeType,
  searchTerm?: string,
  tag?: string,
  playerId?: string,
  tournamentId?: string
): queryParams => {
  if (categoryId) {
    qs["categoryId"] = categoryId;
  } else if (categoryId === "") {
    delete qs.categoryId;
  }
  if (typeId) {
    qs["typeId"] = typeId;
  } else if (typeId === "") {
    delete qs.typeId;
  }
  if (playerId) {
    qs["playerId"] = playerId;
  } else if (playerId === "") {
    delete qs.playerId;
  }
  if (searchTerm) {
    qs["searchTerm"] = searchTerm;
  } else if (searchTerm === "") {
    delete qs.searchTerm;
  }
  if (tag) {
    qs["tag"] = tag;
  } else if (tag === "") {
    delete qs.tag;
  }
  if (tournamentId) {
    qs["tournamentId"] = tournamentId;
  } else if (tournamentId === "") {
    delete qs.tournamentId;
  }
  if (dateRange && dateRange.startDate) {
    qs["startDate"] = dateRange.startDate.format("YYYY-MM-DD");
  } else {
    delete qs.startDate;
  }
  if (dateRange && dateRange.endDate) {
    qs["endDate"] = dateRange.endDate.format("YYYY-MM-DD");
  } else {
    delete qs.endDate;
  }
  return qs;
};

const defaultCode = location.pathname.length
  ? location.pathname.split("/").filter(a => a)[0]
  : "";

const ArticleList = (props: ArticleListProps) => {
  // props
  const { pageType, LanguageCode = defaultCode || "en" } = props;

  // get initial values from query params
  let qs: queryParams = queryString.parse(location.search);
  let initialCategoryId = qs.categoryId ? qs.categoryId : undefined;
  let initialCategory, initialType;
  let initialTypeId = qs.typeId ? qs.typeId : undefined;
  let initialStartDate = qs.startDate ? qs.startDate : undefined;
  let initialEndDate = qs.endDate ? qs.endDate : undefined;
  ``;
  let initialPlayerId = qs.playerId ? qs.playerId : undefined;
  let initialTag = qs.tag ? qs.tag : undefined;
  let initialSearchTerm = qs.searchTerm ? qs.searchTerm : undefined;
  let initialTournamentId = qs.tournamentId ? qs.tournamentId : undefined;
  let initialDateRange: dateRangeType = {
    endDate: null,
    startDate: null
  };
  if (initialStartDate) {
    initialDateRange.startDate = moment(initialStartDate);
  }
  if (initialEndDate) {
    initialDateRange.endDate = moment(initialEndDate);
  }
  if (initialCategoryId) {
    initialCategory = props.articleCategories.filter(item => {
      return item.value === initialCategoryId;
    })[0];
  }
  if (initialTypeId && props.articleTypes) {
    initialType = props.articleTypes.filter(item => {
      return item.value === initialTypeId;
    })[0];
  }

  // set up hooks
  const [items, setItems] = useState<ArticleProps[]>([]);
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [category, setCategory] = useState<dropdownItem | undefined>(
    initialCategory
  );
  const [tag, setTag] = useState<string | undefined>(initialTag);
  const [typeId, setTypeId] = useState<string | undefined>(initialTypeId);
  const [playerId, setPlayerId] = useState<string | undefined>(initialPlayerId);
  const [tournamentId, setTournamentId] = useState<string | undefined>(
    initialTournamentId
  );
  const [dateRange, setDateRange] = useState<dateRangeType>(initialDateRange);
  const [searchTerm, setSearchTerm] = useState<string | undefined>(
    initialSearchTerm
  );

  let type;
  if (props.articleTypes) {
    type = props.articleTypes.filter(item => {
      return item.value === typeId;
    })[0];
  }

  const fetchData = async (
    page: number,
    pageType: "articles" | "photos",
    category?: string | number | undefined,
    type?: string | undefined,
    dateRange?: dateRangeType,
    playerId?: string,
    tournamentId?: string,
    tag?: string,
    searchTerm?: string,
    defaultCode?: string
  ) => {
    setIsError(false);
    setIsLoading(true);
    try {
      const result = await getNews(
        page,
        pageType,
        category,
        type,
        dateRange,
        playerId,
        tournamentId,
        tag,
        searchTerm,
        defaultCode
      );
      if (page !== 1) {
        setItems(items.concat(result.items));
      } else {
        setItems(result.items);
      }
      setTotalItems(result.totalItems);
    } catch (error) {
      setIsError(true);
    }

    setIsLoading(false);
  };

  // handle pagination change
  useEffect(() => {
    // work out new url parameters
    const categoryId = category ? category.value : undefined;
    const tId = tournamentId ? tournamentId : "";
    qs = setUrlParams(
      qs,
      categoryId,
      typeId,
      dateRange,
      searchTerm,
      tag,
      undefined,
      tId
    );

    // update url in browsers
    var url = window.location.href;
    var urlSplit = url.split("?");
    history.pushState({}, "", urlSplit[0] + "?" + queryString.stringify(qs));

    // get latest data
    fetchData(
      page,
      pageType,
      categoryId,
      typeId,
      dateRange,
      playerId,
      tournamentId,
      tag,
      searchTerm,
      LanguageCode
    );
    setTournamentId(undefined);
  }, [
    page,
    category,
    typeId,
    dateRange,
    playerId,
    // tournamentId,
    tag,
    searchTerm
  ]);

  return (
    <ArticleListUi
      LanguageCode={
        currentLanguages.some((l: string) => l === LanguageCode)
          ? LanguageCode
          : "en"
      }
      articleCategories={props.articleCategories}
      articleTypes={props.articleTypes}
      items={items}
      isLoading={isLoading}
      isError={isError}
      totalItems={totalItems}
      setPage={setPage}
      setCategory={setCategory}
      setDateRange={setDateRange}
      setPlayerId={setPlayerId}
      setTournamentId={setTournamentId}
      setTypeId={setTypeId}
      setTag={setTag}
      setSearchTerm={setSearchTerm}
      searchTerm={searchTerm}
      dateRange={dateRange}
      category={category}
      initialType={initialType}
      page={page}
      pageType={props.pageType}
      pageOptions={props.pageOptions}
      heroImgUrl={props.heroImgUrl}
      type={type}
    />
  );
};

export default ArticleList;
